import * as React from 'react';
import { MediaQuery, Util } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';

const BlogDetailHeader = ({ image , mobileImage , title , scrollTo  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const imageUrl = isSmallScreen && mobileImage ? mobileImage.url : image.url;
    if (!imageUrl) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "blog-detail-header",
        style: Util.createCssImageSetStyle(imageUrl, isSmallScreen ? 1024 : 1920, {
            fit: 'scale'
        }, {
            extraPixelDensities: [
                2
            ],
            style: {
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }
        })
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "blog-detail-header__title"
    }, title));
};

export { BlogDetailHeader as default };
//# sourceMappingURL=BlogDetailHeader.js.map
